import { render, staticRenderFns } from "./printreciept.vue?vue&type=template&id=6bce60d9"
import script from "./printreciept.vue?vue&type=script&lang=js"
export * from "./printreciept.vue?vue&type=script&lang=js"
import style0 from "./printreciept.vue?vue&type=style&index=0&id=6bce60d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports